import HandleRemove from "./Handle_remove";

const remove_server_side = async (
  e,
  user,
  userInfo,
  item,
  handleAlert,
  setGif,
  remove_item
) => {
  setGif(true);
  e.preventDefault();

  let response = await HandleRemove({
    userInfo,
    user,
    item,
    remove_item,
  });
  if (response) {
    setGif(false);
    console.clear();
    handleAlert({
      show: true,
      type: "success",
      text: "Item removed with success",
    });
    console.log(response);
  } else {
    setGif(false);
    handleAlert({ show: true, type: "error", text: "Something went wrong" });
  }
};

export { remove_server_side as default };
